import UserError from './UserError.js'

export class SaveContactTokenUserError extends UserError {}
